/* eslint-disable prettier/prettier */
export function buildHost() {
    // console.log("buildHost");
    let host = new URL(window.location.href).hostname;;
    if (window.msizerConfiguration.seamlessToken) {
        host += "/myschneider";
    }
    // if (window.msizerConfiguration.isWorkspaceAvailable) {
    //     host += '/workspace';
    // } else if (window.msizerConfiguration.launchFromWorkspace) {
    //     host += '/from-hmc';
    // }
    return host;
}

export const aggregateProductsQuantities = (products) => {
    // console.log("aggregateProductsQuantities");
    const tmpProducts = [];
    products.forEach((product) => {
        if (product.quantity <= 0) return;
        const existIndex = tmpProducts.findIndex((pdct) => pdct.commercialReference === product.commercialReference);
        if (existIndex > -1) {
            tmpProducts[existIndex].quantity += product.quantity;
        } else {
            tmpProducts.push({ ...product });
        }
    });
    return tmpProducts;
};

export const isWorkspaceAvailable = () => {
    return window.msizerConfiguration?.isWorkspaceAvailable || window.msizerConfiguration?.launchFromWorkspace;
};

export const isUnifiedCheckoutAvailable = () => {
    return window.msizerConfiguration?.unifiedCheckoutAvailable || !!window.msizerConfiguration.buttons?.addToListConfiguration?.isVisible;
};

export const getChannel = () => {
    try {
        return window.top.__dynatrace_channel
    } catch {}
    return window.__dynatrace_channel;
};

export const getSubChannel = () => {
    try {
        return window.top.__dynatrace_subchannel
    } catch {}
    return window.__dynatrace_subchannel;
};

export const getNominalToqueMultiplicator = (configuration_type) => {
    const lowercasedType = configuration_type?.toLowerCase();

    // Check if the configuration type is "cartesian"
    if (lowercasedType === "cartesian") {
      return 2;
    } 
  
    // Default multiplier if the configuration type doesn't match any specific case
    return 1.3;
};
